import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Box,
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Slider,
  Card,
  CardMedia,
  Button,
  Rating,
  InputAdornment,
  Paper,
  Pagination,
  Skeleton,
  Fade,
  Slide,
  Chip,
} from "@mui/material";
import googleIcon from "../images/google_image.png";
import { DatePicker } from "@mui/x-date-pickers";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { searchAPI } from "../API/Seach";
import { debounce } from "lodash";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Popper from "@mui/material/Popper";
import TravelersModal from "./Modals/TravellerModal";
import Loader from "./Loader";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { tokens } from "../theme/tokens";
import { buildOccupanciesFromTravelers } from "../Utils/occupancies";

const SearchResults = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { searchResults, searchParams } = location.state || {};
  console.log(searchResults, "dddddddddddddddddddddddddddddddddddddd")
  const userId = parseInt(localStorage.getItem("userId"), 10);

  // Initialize state variables
  const [priceRange, setPriceRange] = useState([0, 50000]);
  const [searchText, setSearchText] = useState(
    searchParams?.location?.name || ""
  );
  const [locationSearchResults, setLocationSearchResults] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [noDataFound, setNoDataFound] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(
    searchParams?.location || null
  );
  const [openTravelersModal, setOpenTravelersModal] = useState(false);
  const [travelers, setTravelers] = useState(
    searchParams?.travelers || {
      adults: 1,
      children: 0,
      rooms: 1,
      childAges: []
    }
  );
  const [checkIn, setCheckIn] = useState(
    dayjs(searchParams?.checkIn || new Date())
  );
  const [checkOut, setCheckOut] = useState(
    dayjs(searchParams?.checkOut || new Date())
  );
  // New API: searchResults is the .data object from /api/Hotel/search
  // shape: { query, totalPages, currentPage, totalCount, data: [ ...hotels ] }
  const [hotels, setHotels] = useState(searchResults?.data || []);
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
  const [selectedPriceRanges, setSelectedPriceRanges] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPaginated, setIsPaginated] = useState(false);
  const [currentTraceId, setCurrentTraceId] = useState(searchResults?.query?.traceId || null);
  const [availabilityFilters, setAvailabilityFilters] = useState({
    freeBreakfast: false,
    isRefundable: false,
  });
  const [selectedUserRating, setSelectedUserRating] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(searchResults?.totalPages || 1);
  const [searchError, setSearchError] = useState(false);

    const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  const travelersString = `${
    travelers.adults + travelers.children
  } travelers, ${travelers.rooms} room${travelers.rooms > 1 ? "s" : ""}`;

  const handleAvailabilityChange = (event) => {
    const { name } = event.target;
    setAvailabilityFilters((prev) => ({
      ...prev,
      [name === "Free Breakfast" ? "freeBreakfast" : "isRefundable"]:
        event.target.checked,
    }));
  };

  const LoadingSkeletons = () => (
    <Box sx={{ p: 1 }}>
      {[1, 2, 3].map((item, index) => (
        <Slide
          key={item}
          direction="down"
          in={true}
          timeout={300}
          style={{ transitionDelay: `${index * 100}ms` }}
        >
          <Box
            sx={{
              p: 2,
              borderBottom: `1px solid ${tokens.border}`,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <LocationOnIcon sx={{ color: tokens.textMuted, fontSize: "1.2rem" }} />
            <Box sx={{ flex: 1 }}>
              <Skeleton 
                variant="text" 
                width="70%" 
                height={24}
                sx={{ 
                  bgcolor: 'rgba(0,0,0,0.06)',
                  borderRadius: '4px',
                  mb: 0.5
                }}
              />
              <Skeleton 
                variant="text" 
                width="50%" 
                height={20}
                sx={{ 
                  bgcolor: 'rgba(0,0,0,0.04)',
                  borderRadius: '4px'
                }}
              />
            </Box>
          </Box>
        </Slide>
      ))}
    </Box>
  );

  const NoResultsFound = ({ searchQuery }) => (
    <Slide
      direction="down"
      in={true}
      timeout={300}
    >
      <Box
        sx={{
          p: 3,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            backgroundColor: "rgba(0,0,0,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1,
          }}
        >
          <Typography sx={{ fontSize: "1.5rem" }}>🔍</Typography>
        </Box>
        <Typography
          variant="body1"
          sx={{ 
            fontWeight: 500,
            color: tokens.text,
            fontSize: "0.95rem"
          }}
        >
          No results found
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: "0.82rem", maxWidth: "250px" }}
        >
          We couldn't find any locations matching "{searchQuery}". Try searching for a city, hotel, or landmark.
        </Typography>
      </Box>
    </Slide>
  );

  const SearchResultItem = ({ result, onClick, index }) => (
    <Slide
      direction="down"
      in={true}
      timeout={300}
      style={{ transitionDelay: `${index * 50}ms` }}
    >
      <Box
        onClick={() => onClick(result)}
        sx={{
          p: 2,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 1,
          "&:hover": {
            backgroundColor: "rgba(0,113,194,0.08)",
          },
          borderBottom: `1px solid ${tokens.border}`,
          transition: "all 0.2s ease",
          "&:last-child": {
            borderBottom: "none",
          },
        }}
      >
        <LocationOnIcon sx={{ color: tokens.accent, fontSize: "1.2rem" }} />
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="body1"
            sx={{ 
              fontWeight: 500,
              color: tokens.text,
              fontSize: "0.95rem"
            }}
          >
            {result.name}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "0.82rem" }}
          >
            {`${result.city ? result.city + ', ' : ''}${result.state ? result.state + ', ' : ''}${result.country}`}
          </Typography>
        </Box>
      </Box>
    </Slide>
  );

  const handleUserRatingChange = (event) => {
    const { checked, value } = event.target;
    setSelectedUserRating(checked ? value : []);
  };

const createSearchPayload = (location, checkIn, checkOut, travelers, currentPage = 1, usePagination = false) => {
    // Calculate minPrice and maxPrice from selected price ranges
    const prices = selectedPriceRanges.map((range) =>
      range.split("-").map(Number)
    );
    const minPrice = prices.length
      ? Math.min(...prices.map((p) => p[0]))
      : 0;
    const maxPrice = prices.length
      ? Math.max(...prices.map((p) => p[1]))
      : 0;

    return {
      UserId: userId,
      locationId: location.type !== "Hotel" ? parseInt(location.id) : 0,
      hotelId: location.type === "Hotel" ? [location.id.toString()] : [],
      checkIn: checkIn.format("YYYY-MM-DD"),
      checkOut: checkOut.format("YYYY-MM-DD"),
      occupancies: buildOccupanciesFromTravelers(travelers),
      filterBy: {
        ratings: selectedRatings.length > 0 ? selectedRatings : [],
        freeBreakfast: availabilityFilters.freeBreakfast,
        isRefundable: availabilityFilters.isRefundable,
        subLocationIds: [],
        facilities: [],
        type: selectedPropertyTypes.join(", ") || null,
        tags: [],
        reviewRatings: selectedUserRating,
        minPrice: minPrice,
        maxPrice: maxPrice,
      },
      page: currentPage,
      traceId: (usePagination || currentPage > 1) ? currentTraceId : null,
    };
  };

  const fetchHotels = async (pageNumber = 1) => {
    if (!selectedLocation) {
      toast.warning("Please select a location first");
      return;
    }
    if (!checkIn || !checkOut) {
      toast.warning("Please select check-in and check-out dates");
      return;
    }

    setIsLoading(true);
    setSearchError(false);
    setPage(pageNumber);
     scrollToTop();

    const payload = createSearchPayload(
      selectedLocation,
      checkIn,
      checkOut,
      travelers,
      pageNumber
    );

    try {
      const response = await searchAPI.searchHotels(payload);

      if (response.status === "success" && response.statusCode === 200) {
        const apiData = response?.data;
        const hotelsData = apiData?.data || [];
        const totalPagesFromApi = apiData?.totalPages || 1;
        const newTraceId = apiData?.query?.traceId || null;

        setHotels(hotelsData);
        setTotalPages(totalPagesFromApi);
        setCurrentTraceId(newTraceId);
        setSearchError(false);
      } else {
        throw new Error(response.message || "Search failed");
      }
    } catch (error) {
      console.error("Failed to search hotels:", error);
      setSearchError(true);
      setHotels([]);
      setTotalPages(1);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCardClick = async (hotelId) => {
    if (!checkIn || !checkOut) {
      toast.warning("Please select check-in and check-out dates");
      return;
    }
    setIsLoading(true);
    
    // Create updated query with current search parameters
    const updatedQuery = {
      userId: userId,
      locationId: selectedLocation?.type !== "Hotel" ? parseInt(selectedLocation?.id) : 0,
      hotelId: selectedLocation?.type === "Hotel" ? [selectedLocation?.id.toString()] : [],
      checkIn: checkIn.format("YYYY-MM-DD"),
      checkOut: checkOut.format("YYYY-MM-DD"),
      nationality: null,
      occupancies: buildOccupanciesFromTravelers(travelers),
      filterBy: {
        freeBreakfast: availabilityFilters.freeBreakfast,
        isRefundable: availabilityFilters.isRefundable,
        subLocationIds: [],
        ratings: selectedRatings.length > 0 ? selectedRatings : [],
        hotelName: null,
        type: selectedPropertyTypes.join(", ") || null,
        tags: [],
        facilities: [],
        reviewRatings: selectedUserRating
        },
        page: page,
        traceId: currentTraceId
      };

    const payload = {
      query: updatedQuery,
      traceId: currentTraceId,
      hotelId: hotelId,
    };

    try {
      const response = await searchAPI.getHotelDetails(payload);
      setIsLoading(true);
      navigate("/hotel-search", {
        state: {
          searchResults: response.data,
          locationName: searchText,
          searchParams: {
            location: selectedLocation,
            checkIn: checkIn.format("YYYY-MM-DD"),
            checkOut: checkOut.format("YYYY-MM-DD"),
            travelers: travelers
          }
        },
      });
    } catch (error) {
      setIsLoading(true);
      console.error("Error making API call:", error);
    }
  };

  const handleSearch = debounce(async (text) => {
    if (text.length >= 3) {
      setLoading(true);
      setNoDataFound(false);
      try {
        const response = await searchAPI.searchLocation(text);
        const locations = response?.data?.locations || [];

        if (response.status === "success" && response.statusCode === 200) {
          if (locations.length > 0) {
            setLocationSearchResults(locations);
            setNoDataFound(false);
          } else {
            setLocationSearchResults([]);
            setNoDataFound(true);
          }
        } else {
          setLocationSearchResults([]);
          setNoDataFound(true);
        }
      } catch (error) {
        console.error("Search failed:", error);
        setLocationSearchResults([]);
        setNoDataFound(true);
      } finally {
        setLoading(false);
      }
    } else {
      setLocationSearchResults([]);
      setNoDataFound(false);
    }
  }, 300);

  const handleSearchTextChange = (e) => {
    const newValue = e.target.value;
    setSearchText(newValue);
    if (newValue === "") {
      setSelectedLocation(null);
    }
    setIsPaginated(false);
    setAnchorEl(e.currentTarget);
    handleSearch(newValue);
  };

  const handleLocationSelect = (location) => {
    setSearchText(location.fullName || location.name);
    setSelectedLocation(location);
    setLocationSearchResults([]);
    setAnchorEl(null);
    setIsPaginated(false);
  };

  const handleTravelersChange = (newTravelers) => {
    setTravelers(newTravelers);
  };

  // Function to handle rating selection
  const handleRatingChange = (event) => {
    const rating = event.target.value === "Other" ? 0 : Number(event.target.value);
    setSelectedRatings(prevRatings => {
      if (prevRatings.includes(rating)) {
        return prevRatings.filter(r => r !== rating);
      } else {
        return [...prevRatings, rating];
      }
    });
  };

  // Function to handle property type selection
  const handlePropertyTypeChange = (event) => {
    const type = event.target.name.toLowerCase();
    setSelectedPropertyTypes((prevTypes) =>
      prevTypes.includes(type)
        ? prevTypes.filter((t) => t !== type)
        : [...prevTypes, type]
    );
  };

  // Function to handle price range selection
  const handlePriceRangeChange = (event) => {
    const range = event.target.name;
    setSelectedPriceRanges((prevRanges) =>
      prevRanges.includes(range)
        ? prevRanges.filter((r) => r !== range)
        : [...prevRanges, range]
    );
  };

  // Add handlePageChange function for pagination
  const handlePageChange = (event, newPage) => {
    setIsPaginated(true);
    fetchHotels(newPage);
  };

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Box sx={{ bgcolor: tokens.surface, minHeight: "100vh", pt: { xs: "88px", md: "96px" } }}>
        {" "}
        <Box
          sx={{
            bgcolor: tokens.paper,
            py: 2,
            borderBottom: `1px solid ${tokens.border}`,
            ml: 2,
            mr: 2,
            top: "64px",
            zIndex: 1000,
          }}
        >
          <Container maxWidth="xl">
            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "flex-end",
                flexDirection: { xs: "column", md: "row" },
                width: { xs: "100%", md: "100%" },
                mt: { xs: 2 },
              }}
            >
              {/* Where to? Field with floating label */}
              <Box sx={{ flex: 2, width: "100%", position: "relative" }}>
                <Typography
                  variant="caption"
                  sx={{
                    position: "absolute",
                    top: -10,
                    left: 12,
                    backgroundColor: "white",
                    px: 0.5,
                    color: "text.secondary",
                    fontSize: "0.75rem",
                    zIndex: 1,
                    fontWeight: "bold",
                  }}
                >
                  Where to? *
                </Typography>
                <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                  <Box sx={{ position: "relative", width: "100%" }}>
                    <TextField
                      value={searchText}
                      placeholder="City, area, or landmark"
                      size="small"
                      fullWidth
                      required
                      onChange={handleSearchTextChange}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          "& fieldset": {
                            borderColor: tokens.border,
                          },
                          "&:hover fieldset": {
                            borderColor: tokens.textMuted,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: tokens.accent,
                          },
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationOnIcon sx={{ color: tokens.textMuted }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Popper
                      open={Boolean(anchorEl) && (locationSearchResults.length > 0 || loading || noDataFound)}
                      anchorEl={anchorEl}
                      placement="bottom-start"
                      style={{ width: anchorEl?.offsetWidth, zIndex: 1301 }}
                      transition
                    >
                      {({ TransitionProps }) => (
                        <Fade {...TransitionProps} timeout={200}>
                          <Paper
                            sx={{
                              mt: 1,
                              maxHeight: "300px",
                              overflowY: "auto",
                              borderRadius: "16px",
                              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                              border: "1px solid rgba(0,0,0,0.08)",
                              backdropFilter: "blur(8px)",
                              backgroundColor: "rgba(255,255,255,0.95)",
                            }}
                          >
                            {loading ? (
                              <LoadingSkeletons />
                            ) : locationSearchResults.length > 0 ? (
                              locationSearchResults.map((result, index) => (
                                <SearchResultItem
                                  key={result.id}
                                  result={result}
                                  onClick={handleLocationSelect}
                                  index={index}
                                />
                              ))
                            ) : noDataFound ? (
                              <NoResultsFound searchQuery={searchText} />
                            ) : null}
                          </Paper>
                        </Fade>
                      )}
                    </Popper>
                  </Box>
                </ClickAwayListener>
              </Box>

              {/* Check-in Check-out Fields with separate floating labels */}
              <Box sx={{ flex: 1.5, width: "100%", display: "flex", gap: 1 }}>
                {/* Check-in Date Picker */}
                <Box sx={{ flex: 1, position: "relative" }}>
                  <Typography
                    variant="caption"
                    sx={{
                      position: "absolute",
                      top: -8,
                      left: 12,
                      backgroundColor: "white",
                      px: 0.5,
                      color: "text.secondary",
                      fontSize: "0.75rem",
                      zIndex: 1,
                      fontWeight: "bold",
                    }}
                  >
                    Check-in *
                  </Typography>
                  <DatePicker
                    value={checkIn}
                    onChange={(newValue) => {
                      setCheckIn(newValue);
                      if (newValue && checkOut && !checkOut.isAfter(newValue)) {
                        setCheckOut(newValue.add(1, "day"));
                      }
                    }}
                    minDate={dayjs()}
                    format="DD-MM-YYYY"
                    slotProps={{
                      textField: {
                        size: "small",
                        required: true,
                        sx: {
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: `${tokens.radiusSm}px`,
                            "& fieldset": {
                              borderColor: tokens.border,
                            },
                            "&:hover fieldset": {
                              borderColor: tokens.textMuted,
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: tokens.accent,
                            },
                          },
                        },
                      },
                      actionBar: {
                        actions: ["today", "clear"],
                      },
                    }}
                  />
                </Box>

                {/* Check-out Date Picker */}
                <Box sx={{ flex: 1, position: "relative" }}>
                  <Typography
                    variant="caption"
                    sx={{
                      position: "absolute",
                      top: -8,
                      left: 12,
                      backgroundColor: "white",
                      px: 0.5,
                      color: "text.secondary",
                      fontSize: "0.75rem",
                      zIndex: 1,
                      fontWeight: "bold",
                    }}
                  >
                    Check-out *
                  </Typography>
                  <DatePicker
                    value={checkOut}
                    onChange={(newValue) => setCheckOut(newValue)}
                    minDate={
                      checkIn ? checkIn.add(1, "day") : dayjs().add(1, "day")
                    }
                    format="DD-MM-YYYY"
                    slotProps={{
                      textField: {
                        size: "small",
                        required: true,
                        sx: {
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: `${tokens.radiusSm}px`,
                            "& fieldset": {
                              borderColor: tokens.border,
                            },
                            "&:hover fieldset": {
                              borderColor: tokens.textMuted,
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: tokens.accent,
                            },
                          },
                        },
                      },
                      actionBar: {
                        actions: ["today", "clear"],
                      },
                    }}
                  />
                </Box>
              </Box>

              {/* Travelers Field with floating label */}
              <Box sx={{ flex: 1, width: "100%", position: "relative" }}>
                <Typography
                  variant="caption"
                  sx={{
                    position: "absolute",
                    top: -8,
                    left: 12,
                    backgroundColor: "white",
                    px: 0.5,
                    color: "text.secondary",
                    fontSize: "0.75rem",
                    zIndex: 1,
                    fontWeight: "bold",
                  }}
                >
                  Travelers *
                </Typography>
                <TextField
                  value={travelersString}
                  size="small"
                  fullWidth
                  required
                  onClick={() => setOpenTravelersModal(true)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      cursor: "pointer",
                      userSelect: "none",
                      "& fieldset": {
                        borderColor: tokens.border,
                      },
                      "&:hover fieldset": {
                        borderColor: tokens.textMuted,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: tokens.accent,
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonOutlineIcon sx={{ color: tokens.textMuted }} />
                      </InputAdornment>
                    ),
                    readOnly: true,
                  }}
                />
                <TravelersModal
                  isOpen={openTravelersModal}
                  handleClose={() => setOpenTravelersModal(false)}
                  onTravelersChange={handleTravelersChange}
                  initialTravelers={travelers}
                />
              </Box>

              {/* Search Button */}
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={() => {
                  setIsPaginated(false);
                  fetchHotels();
                }}
                sx={{
                  bgcolor: tokens.brand,
                  borderRadius: `${tokens.radiusSm}px`,
                  "&:hover": { bgcolor: tokens.brandDeep },
                  height: 40,
                  mb: 0.5,
                  width: { xs: "100%", md: "auto" },
                }}
              >
                Search
              </Button>
            </Box>
          </Container>
        </Box>
        <Container
          maxWidth="xl"
          sx={{
            mt: 2,
            px: { xs: 2, sm: 2.5, md: 3 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: { xs: 2, md: 2.5 },
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "300px" },
                flexShrink: 0,
                alignSelf: "flex-start",
              }}
            >
              <Card
                sx={{
                  p: 2,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                  borderRadius: "12px",
                }}
              >
                {/* Popular Filters */}
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Filter by
                </Typography>
                {/* Property Type */}
                <Box sx={{ mb: 3 }}>
                  <Typography sx={{ fontWeight: 500, mb: 1 }}>
                    Property type
                  </Typography>
                  {["Hotels", "Apartments", "Villas", "Home Stays"].map(
                    (type) => (
                      <FormControlLabel
                        key={type}
                        control={
                          <Checkbox
                            size="small"
                            checked={selectedPropertyTypes.includes(
                              type.toLowerCase()
                            )}
                            onChange={handlePropertyTypeChange}
                            name={type}
                          />
                        }
                        label={type}
                        sx={{
                          display: "block",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.875rem",
                            color: tokens.text,
                          },
                        }}
                      />
                    )
                  )}
                </Box>
                <Box sx={{ mb: 3 }}>
                  <Typography sx={{ fontWeight: 500, mb: 1 }}>
                    Availability
                  </Typography>
                  {[
                    { label: "Free Breakfast", key: "freeBreakfast" },
                    { label: "Refundable", key: "isRefundable" },
                  ].map((type) => (
                    <FormControlLabel
                      key={type.key}
                      control={
                        <Checkbox
                          size="small"
                          name={type.label}
                          checked={availabilityFilters[type.key]}
                          onChange={handleAvailabilityChange}
                        />
                      }
                      label={type.label}
                      sx={{
                        display: "block",
                        "& .MuiFormControlLabel-label": {
                          fontSize: "0.875rem",
                          color: tokens.text,
                        },
                      }}
                    />
                  ))}
                </Box>
                <Box sx={{ mb: 3 }}>
                  <Typography sx={{ fontWeight: 500, mb: 1 }}>
                    Price Range
                  </Typography>
                  {[
                    "0-2000",
                    "2001-5000",
                    "5001-8000",
                    "8001-12000",
                    "12001-20000",
                  ].map((range) => (
                    <FormControlLabel
                      key={range}
                      control={
                        <Checkbox
                          size="small"
                          checked={selectedPriceRanges.includes(range)}
                          onChange={handlePriceRangeChange}
                          name={range}
                        />
                      }
                      label={`₹${range.replace("-", " - ₹")}`}
                      sx={{
                        display: "block",
                        "& .MuiFormControlLabel-label": {
                          fontSize: ".875rem",
                          color: tokens.text,
                        },
                      }}
                    />
                  ))}
                </Box>
                {/* Price Range */}
                <Box sx={{ mb: 3 }}>
                  <Typography sx={{ fontWeight: 500, mb: 1 }}>
                    Star Rating
                  </Typography>
                  {[
                    { label: "5 Star", value: 5 },
                    { label: "4 Star", value: 4 },
                    { label: "3 Star", value: 3 },
                    { label: "Other", value: "Other" }
                  ].map((rating) => (
                    <FormControlLabel
                      key={rating.value}
                      control={
                        <Checkbox
                          size="small"
                          checked={selectedRatings.includes(rating.value === "Other" ? 0 : rating.value)}
                          onChange={handleRatingChange}
                          value={rating.value}
                        />
                      }
                      label={rating.label}
                      sx={{
                        display: "block",
                        "& .MuiFormControlLabel-label": {
                          fontSize: ".875rem",
                          color: tokens.text,
                        },
                      }}
                    />
                  ))}
                </Box>
                <Box sx={{ mb: 3 }}>
                  <Typography sx={{ fontWeight: 500, mb: 1 }}>
                    User Rating
                  </Typography>
                  {[
                    { label: "Excellent: 4.5+ Rating", value: "4.5" },
                    { label: "Very Good: 4+ Rating", value: "4" },
                    { label: "Good: 3.5+ Rating", value: "3.5" },
                    { label: "Pleasant: 3+ Rating", value: "3" },
                  ].map((rating) => (
                    <FormControlLabel
                      key={rating.value}
                      control={
                        <Checkbox
                          size="small"
                          checked={selectedUserRating === rating.value}
                          onChange={handleUserRatingChange}
                          value={rating.value}
                        />
                      }
                      label={rating.label}
                      sx={{
                        display: "block",
                        "& .MuiFormControlLabel-label": {
                          fontSize: ".875rem",
                          color: tokens.text,
                        },
                      }}
                    />
                  ))}
                </Box>
              </Card>
            </Box>

            <Box
              sx={{
                flex: 1,
                maxWidth: "100%",
                minWidth: 0,
              }}
            >
              {" "}
              {/* Hotel Cards */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                {searchError ? (
                  <Card
                    sx={{
                      p: 4,
                      textAlign: "center",
                      borderRadius: "12px",
                      backgroundColor: tokens.paper,
                      boxShadow: tokens.shadowSm,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: 64,
                          height: 64,
                          borderRadius: "50%",
                          backgroundColor: "rgba(255,99,99,0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 1,
                        }}
                      >
                        <Typography sx={{ fontSize: "2rem" }}>😔</Typography>
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: tokens.text,
                          mb: 1,
                        }}
                      >
                        No Hotels Listed
                      </Typography>
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{
                          maxWidth: "400px",
                          lineHeight: 1.6,
                        }}
                      >
                        We're sorry, but we couldn't find any hotels for your search criteria. 
                        Please try adjusting your dates, location, or filters and search again.
                      </Typography>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setSearchError(false);
                          fetchHotels();
                        }}
                        sx={{
                          mt: 2,
                          bgcolor: tokens.brand,
                          "&:hover": { bgcolor: tokens.brandDeep },
                          borderRadius: `${tokens.radiusSm}px`,
                          textTransform: "none",
                        }}
                      >
                        Try Again
                      </Button>
                    </Box>
                  </Card>
                ) : hotels.length === 0 ? (
                  <Card
                    sx={{
                      p: 4,
                      textAlign: "center",
                      borderRadius: "12px",
                      backgroundColor: tokens.paper,
                      boxShadow: tokens.shadowSm,
                    }}
                  >
                    <Typography variant="h6" color="text.secondary">
                      No hotels found for your search criteria.
                    </Typography>
                  </Card>
                ) : (
                  hotels.map((hotel) => {
                  const soldOut = hotel.isAvailable === false;
                  return (
                  <Card
                    key={hotel.hotelId}
                    sx={{
                      display: "flex",
                      borderRadius: "12px",
                      p: { xs: 1.5, sm: 2 },
                      flexDirection: { xs: "column", sm: "row" },
                      position: "relative",
                      opacity: soldOut ? 0.92 : 1,
                    }}
                  >
                    {/* View Details Button */}
                    <Button
                      variant="contained"
                      disabled={soldOut}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!soldOut) handleCardClick(hotel.hotelId);
                      }}
                      sx={{
                        position: { xs: "static", sm: "absolute" }, 
                        top: { sm: 16 },
                        right: { sm: 16 },
                        bgcolor: tokens.brand,
                        color: "#fff",
                        textTransform: "none",
                        borderRadius: `${tokens.radiusXl}px`,
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        "&:hover": {
                          bgcolor: tokens.brandDeep,
                        },
                        "&.Mui-disabled": {
                          bgcolor: tokens.border,
                          color: tokens.textMuted,
                        },
                        zIndex: 1,
                        
                        width: { xs: "100%", sm: "auto" }, 
                        mt: { xs: 2, sm: 0 }, 
                        mb: { xs: 1, sm: 0 }, 
                        order: { xs: 999, sm: "unset" }, // Push to bottom on mobile
                      }}
                    >
                      View Details
                    </Button>

                    {/* Hotel Image */}
                    <Box
                      sx={{
                        position: "relative",
                        width: { xs: "100%", sm: "240px" },
                        flexShrink: 0,
                      }}
                    >
                      {soldOut && (
                        <Chip
                          label="Sold out"
                          size="small"
                          sx={{
                            position: "absolute",
                            top: 8,
                            left: 8,
                            zIndex: 2,
                            fontWeight: 700,
                            bgcolor: "rgba(0,0,0,0.72)",
                            color: "#fff",
                          }}
                        />
                      )}
                      <CardMedia
                        component="img"
                        sx={{
                          width: "100%",
                          height: { xs: "200px", sm: "200px" },
                          borderRadius: 1,
                          objectFit: "cover",
                          cursor: soldOut ? "default" : "pointer",
                          filter: soldOut ? "grayscale(0.35)" : "none",
                        }}
                        image={hotel.heroImage}
                        alt={hotel.name}
                        onClick={() => {
                          if (!soldOut) handleCardClick(hotel.hotelId);
                        }}
                      />
                    </Box>

                    {/* Hotel Details */}
                    <Box
                      sx={{
                        flex: 1,
                        ml: { xs: 0, sm: 2 },
                        mt: { xs: 1.5, sm: 0 },
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          component="img"
                          src={googleIcon}
                          alt="Google"
                          sx={{
                            width: "22px",
                            height: "22px",
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 500,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {hotel.rating || "0"}/5
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: tokens.textMuted, ml: 0.5 }}
                        >
                          ({hotel.count || "0"} Reviews)
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: "1.25rem",
                            fontWeight: 500,
                            color: tokens.text,
                            mb: 1,
                          }}
                        >
                          {hotel.name}
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 1,
                          }}
                        >
                          <Rating
                            value={parseFloat(hotel.starRating)}
                            readOnly
                            size="small"
                          />
                          <Typography variant="body2" sx={{ color: tokens.textMuted }}>
                            {hotel.type}
                          </Typography>
                        </Box>

                        <Typography
                          variant="body2"
                          sx={{ color: tokens.textMuted, mb: 2 }}
                        >
                          {hotel.location}
                        </Typography>

                        {/* Amenities */}
                        <Box
                          sx={{
                            mt: 2,
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              bgcolor: hotel.freeBreakfast
                                ? "rgba(0,166,0,0.1)"
                                : "rgba(255,0,0,0.1)",
                              color: hotel.freeBreakfast
                                ? tokens.success
                                : tokens.error,
                              px: 1,
                              py: 0.5,
                              borderRadius: 1,
                              fontSize: "0.8rem",
                            }}
                          >
                            {hotel.freeBreakfast ? (
                              <CheckCircleIcon sx={{ fontSize: "1rem" }} />
                            ) : (
                              <CancelIcon sx={{ fontSize: "1rem" }} />
                            )}
                            <Typography variant="body2">
                              Free Breakfast
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              bgcolor: hotel.freeCancellation
                                ? "rgba(0,166,0,0.1)"
                                : "rgba(255,0,0,0.1)",
                              color: hotel.freeCancellation
                                ? tokens.success
                                : tokens.error,
                              px: 1,
                              py: 0.5,
                              borderRadius: 1,
                              fontSize: "0.8rem",
                            }}
                          >
                            {hotel.freeCancellation ? (
                              <CheckCircleIcon sx={{ fontSize: "1rem" }} />
                            ) : (
                              <CancelIcon sx={{ fontSize: "1rem" }} />
                            )}
                            <Typography variant="body2">
                              Free Cancellation
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              bgcolor: hotel.refundable
                                ? "rgba(0,166,0,0.1)"
                                : "rgba(255,0,0,0.1)",
                              color: hotel.refundable
                                ? tokens.success
                                : tokens.error,
                              px: 1,
                              py: 0.5,
                              borderRadius: 1,
                              fontSize: "0.8rem",
                            }}
                          >
                            {hotel.refundable ? (
                              <CheckCircleIcon sx={{ fontSize: "1rem" }} />
                            ) : (
                              <CancelIcon sx={{ fontSize: "1rem" }} />
                            )}
                            <Typography variant="body2">Refundable</Typography>
                          </Box>
                        </Box>
                      </Box>

                      <Box>
                        <Box sx={{ mt: 1 }}>
                          {/* Total Price */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 0.5,
                            }}
                          >
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ fontWeight: "bold" }}
                            >
                              {soldOut ? "Availability" : "Total Price"}
                            </Typography>
                          {soldOut ? (
                            <Typography
                              variant="body2"
                              sx={{
                                color: tokens.error,
                                fontWeight: 700,
                                fontSize: "1.1rem",
                              }}
                            >
                              Sold out
                            </Typography>
                          ) : (
                          <Typography
                            variant="body2"
                            sx={{
                              color: tokens.success,
                              fontWeight: 600,
                              fontSize: "1.25rem",
                            }}
                          >
                            <Box component="span" sx={{ color: tokens.text, fontSize: "0.95rem", fontWeight: 500 }}>
                              Starts with{" "}
                            </Box>
                            ₹{(hotel.offerPrice ?? hotel.price ?? 0).toLocaleString()}
                          </Typography>
                          )}
                          </Box>

                          {!soldOut && (
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{
                              display: "block",
                              textAlign: "right",
                              mt: 0.5,
                            }}
                          >
                            includes taxes and fees
                          </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Card>
                  );
                  })
                )}
              </Box>

              {/* Updated Pagination Component */}
              {totalPages > 1 && (
                <Box 
                  sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    mt: 4, 
                    mb: 4,
                    width: '100%',
                    backgroundColor: 'white',
                    py: 2,
                    borderRadius: '8px',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)'
                  }}
                >
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                    siblingCount={1}
                    boundaryCount={1}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        fontSize: "1rem",
                        fontWeight: 600,
                        margin: "0 4px",
                        borderRadius: `${tokens.radiusSm}px`,
                        "&:hover": {
                          backgroundColor: tokens.accentSoft,
                        },
                      },
                      "& .Mui-selected": {
                        backgroundColor: `${tokens.brand} !important`,
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: `${tokens.brandDeep} !important`,
                        },
                      },
                      "& .MuiPaginationItem-ellipsis": {
                        color: tokens.textMuted,
                      },
                    }}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default SearchResults;